import { Suspense, useEffect } from "react";
import useLazyChunk from "src/ui/hooks/useLazyChunk";

import { ChunkLoadErrorBoundary, lazyChunk } from "@shared/ChunkLoadErrorBoundary";

import type { Props } from "./NewCommandDialog";

const importDialog = () => import("./NewCommandDialog").then((module) => ({ default: module.NewCommandDialog }));

const LazyNewCommandDialog = lazyChunk(importDialog);

export const useNewCommandDialogChunk = () => useLazyChunk(importDialog);

export const usePreloadNewCommandDialog = (enabled: boolean) => {
    useEffect(() => {
        if (enabled) {
            importDialog().catch(() => undefined);
        }
    }, [enabled]);
};

export const NewCommandDialog = (props: Props) => (
    <ChunkLoadErrorBoundary onError={props.toggleDialog}>
        <Suspense fallback={null}>
            <LazyNewCommandDialog {...props} />
        </Suspense>
    </ChunkLoadErrorBoundary>
);
